module.exports = require("@swa-ui/error");